import { useMutation } from 'urql';
import { useAccountQuery } from '../../hooks/useAccountQuery';
import { followPropertyV2Mutation } from '../../graphql/account/followPropertyV2Mutation';
import { unfollowPropertyV2Mutation } from '../../graphql/account/unfollowPropertyV2Mutation';
import { PropertyRelationship } from '../../components/PropertyRelationship/PropertyRelationship';

// On following, unfollowing or updating a property relationship, data with the following typenames will be invalidated
const INVALIDATE_PROPERTY_PAGE_HEADER_CTA_TYPENAMES = [
  'PropertyPage_Header_Ctas',
  'PropertyPage_Header_Ctas_V2',
];

export const useFollowedProperties = () => {
  const { data, fetching: accountLoading } = useAccountQuery();

  const followedProperties = data?.account?.followedPropertiesV2?.followedProperties;

  const [{ fetching: followLoading, error: followError }, follow] =
    useMutation(followPropertyV2Mutation);

  const [{ fetching: unfollowLoading, error: unfollowError }, unfollow] = useMutation(
    unfollowPropertyV2Mutation,
  );

  const followProperty = async (propertyId: string, propertyRelationship: PropertyRelationship) => {
    await follow(
      { propertyId, propertyRelationship },
      { additionalTypenames: INVALIDATE_PROPERTY_PAGE_HEADER_CTA_TYPENAMES },
    );
  };

  const updatePropertyRelationship = async (
    updatePropertyId: string,
    propertyRelationship: PropertyRelationship,
  ) => {
    await follow(
      {
        propertyId: updatePropertyId,
        propertyRelationship,
      },
      { additionalTypenames: INVALIDATE_PROPERTY_PAGE_HEADER_CTA_TYPENAMES },
    );
  };

  const unfollowProperty = async (unfollowPropertyId: string) => {
    await unfollow(
      { propertyId: unfollowPropertyId },
      { additionalTypenames: INVALIDATE_PROPERTY_PAGE_HEADER_CTA_TYPENAMES },
    );
  };

  return {
    followedProperties,
    followProperty,
    updatePropertyRelationship,
    unfollowProperty,
    loading: accountLoading || followLoading || unfollowLoading,
    followedPropertiesError: followError ?? unfollowError,
  };
};
